import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "./alert-dialog";
import { useState } from "react";

export type BasicNotificationDisclaimerModalProps = {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onContinue: () => void;
};

export function BasicNotificationDisclaimerModal({
  open,
  onOpenChange,
  onContinue,
}: BasicNotificationDisclaimerModalProps) {
  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent className="max-w-xl gap-5 p-7 text-left">
        <AlertDialogHeader className="space-y-3 text-left sm:text-left">
          <AlertDialogTitle className="text-left text-xl">
            You have selected Basic Notification only
          </AlertDialogTitle>

          <AlertDialogDescription className="space-y-4 pt-3 text-left text-base">
            <span className="block">
              This option does not provide protection—it only alerts you after a
              document is recorded on your property. Notifications may be
              delayed due to county recorders not immediately making data
              public, and there is no financial coverage for losses or legal
              costs.
            </span>

            <span className="block text-base font-medium text-foreground">
              By continuing, you acknowledge you are not protected against fraud
              or unauthorized transactions.
            </span>
          </AlertDialogDescription>
        </AlertDialogHeader>

        <AlertDialogFooter className="flex flex-col-reverse gap-3 sm:flex-row sm:justify-end sm:items-center sm:gap-3 sm:space-x-0">
          <AlertDialogCancel className="mt-0 h-12 px-6 text-base sm:mt-0">
            No, I want protection
          </AlertDialogCancel>

          <AlertDialogAction
            className="mt-0 h-12 px-6 text-base sm:mt-0"
            onClick={() => {
              onContinue();
            }}
          >
            I Understand, Continue
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
